(function () {
	const logoSet = $('.bs-section--home-logos-scroll .media-elements');

	const isScrolledIntoView = (elem) => {
		var docViewTop = $(window).scrollTop();
		var docViewBottom = docViewTop + $(window).height();
		var elemTop = $(elem).offset().top;
		var elemBottom = elemTop + $(elem).height();
		return elemBottom <= docViewBottom && elemTop >= docViewTop;
	};

	const scrollView = () => {
		$('.bs-section--home-logos-scroll .media-elements').each(function () {
			if (isScrolledIntoView(this) === true) {
				$(this).addClass('on-viewport');
			} else {
				$(this).removeClass('on-viewport');
			}
		});
	};

	$(window).on('scroll load', scrollView);
})();
